import React from 'react'
import { Navigate } from 'react-router-dom'
import { isTokenValid } from '../utils/auth'

export default function AdminRoute({ children }) {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    if (!isTokenValid(token)) return <Navigate to="/" replace />;
    if (role !== 'ADMIN' && role !== 'SUPERADMIN') return <Navigate to="/" replace />;
    return children;
}